module.exports = __webpack_public_path__ + "static/media/MHRP51N0003.32f21836.svg";